import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { getPagePartSlug } from '@gov-nx/module/page/definitions/PageMap';
import AuthorizedRoute from '../../routes/AuthorizedRoute';

const DriversRegistryPage = lazy(() =>
	import('./DriversRegistryPage').then(({ DriversRegistryPage }) => ({
		default: DriversRegistryPage,
	}))
);

export const getDriversRegistryRoutes = (): RouteObject[] => [
	{
		path: getPagePartSlug('registr-ridicu'),
		element: (
			<AuthorizedRoute>
				<DriversRegistryPage />
			</AuthorizedRoute>
		),
	},
];
